import { notification } from 'antd';
import { all, call, put, take } from 'redux-saga/effects';
import { LOAD_ASSESSMENT_LIST } from '../type';
import {
  //List
  loadAssessmentListSuccessAction,
  loadAssessmentListErrorAction,
} from '../action';

import { packageService } from 'services';

function* loadAssessmentList() {
  while (1) {
    const action = yield take(LOAD_ASSESSMENT_LIST);
    try {
      const assessmentList = yield call(
        packageService.loadAssessmentGroup,
        action.payload,
      );
      yield put(loadAssessmentListSuccessAction(assessmentList));
    } catch (err) {
      yield put(loadAssessmentListErrorAction(err));
      notification.error({
        message: err.message,
      });
    }
  }
}

export default function* rootSaga() {
  yield all([loadAssessmentList()]);
}
